<template>
    <div>
        <el-dropdown @command="handleCommand">
            <span :class="['cs-homework-score-label', className]">{{scoreText}}</span>
            <el-dropdown-menu slot="dropdown" v-if="canEdit">
                <el-dropdown-item :command="0">差</el-dropdown-item>
                <el-dropdown-item :command="1">中</el-dropdown-item>
                <el-dropdown-item :command="2">良</el-dropdown-item>
                <el-dropdown-item :command="3">优</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<style lang="scss" scoped>
.cs-homework-score-label{
    &:focus{
        border: none;
        outline: 0px solid transparent;
    }
}
</style>

<script>
import {
    getScoreColor
} from "../../../config/mUtils.js"
import {
    markHomework,
} from "../../../service/homework.service";

export default {
    props: {
        data: {}
    },
    data() {
        return {
            canEdit: true,
            scoreText: "",
            hasFile: true,
            Id: 0,
            score: '',
            className: ''
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.score = this.data.Score;
                this.scoreText = this.data.ScoreText;
                this.hasFile = this.data.HasFile;
                this.Id = this.data.Id;
                this.canEdit = this.data.CanEdit;

                this.setScoreClass();
            }
        },

        handleCommand(command) {
            let self = this;
            if (!this.hasFile) {
                this.$message.error("作业未提交，无法评分");
            } else {
                markHomework(this.data.Id, command).then(result => {
                    if (!!result && result.success) {
                        this.$message({
                            type: 'success',
                            message: '评分更新成功!'
                        });
                        let data = {
                            name: "statusChange",
                        };
                        this.$emit("customEvent", data);
                        this.score = command;
                        this.setScoreClass();
                    } else {
                        this.$message({
                            type: 'error',
                            message: '评分更新失败! ' + result.message
                        });
                    }
                });
            }
        },
        setScoreClass(){
            if ( typeof this.score != "undefined" && this.score != null){
                let colorClass = getScoreColor(this.score);
                if (!colorClass){
                    colorClass = "cs-color-frenchgrey";
                }
                this.className = colorClass;
              
            }else{
                this.className = "cs-color-frenchgrey";
            }
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkScoreEditCell.vue